$(document).ready(function(){ 
 var options1 = {
   infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    focusOnSelect: true,
    prevArrow : '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
   	nextArrow : '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',

}
  var options2 = {
   infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    focusOnSelect: true,
    prevArrow : '<button type="button" class="slick-prev cstm_mob"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
   	nextArrow : '<button type="button" class="slick-next cstm_mob"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',

}
if($('.lookbook_slider').length > 0){
$('.lookbook_slider').slick(options1);
}
/*
*images spot on click products change
*/

  $('.cstm_shopthelook__Dot').on('click',function(){ 
 
    $(this).parents('.inner_details').find('.cstm_shopthelook__Dot').removeClass('is-active');
    $(this).addClass('is-active');
    var productIndex = $(this).attr('data-product-index');
   
    //find parents change class in slider spots
    
    $(this).parents('.inner_details').find('.cstm_underprd_dots').removeClass('is-active');
    $(this).parents('.inner_details').find('.cstm_dots_'+productIndex).addClass('is-active');
    // hide show products
    $(this).parents('.inner_details').find('.cstm_products_items').removeClass('is-active');
    $(this).parents('.inner_details').find('.cstm_item'+productIndex).addClass('is-active');
    
  });
  
  
/*
*sliderspot on change 
*/  
  $('.cstm_underprd_dots').on('click',function(){
    var spotIndex = $(this).attr('data-product-index');
    
    $(this).parents('.inner_details').find('.cstm_underprd_dots').removeClass('is-active');
    $(this).addClass('is-active');
    
    
     //find parents change class in slider spots
    
    $(this).parents('.inner_details').find('.cstm_shopthelook__Dot').removeClass('is-active');
    $(this).parents('.inner_details').find('.image_spt'+spotIndex).addClass('is-active');
    // hide show products
    $(this).parents('.inner_details').find('.cstm_products_items').removeClass('is-active');
    $(this).parents('.inner_details').find('.cstm_item'+spotIndex).addClass('is-active');
    
 });
  
/*
*Mobile popup 
*/  
  $('.cstm_mobviewproduct').on('click',function(){
   var popupHtml =  $('.popup_slides').html();
    if(popupHtml !=''){
        $('.popup_slides').slick("unslick");
    }
    var checkActiveProduct = $('.slick-current').find('.cstm_look_item');
    $('.lookbook_popup').addClass('active');
    $('.popup_slides').html(checkActiveProduct.html());
    $('.popup_slides').find('.inner_product').css('display','block');
    $('.popup_slides').find('.desktop_lookbookebtn').css('display','none');
    
    $('.popup_slides').slick(options2);
     $('.popup_slides').find('.is-active').trigger('click');
  });

/*
* close popup
*/  

  $('.close_lookbookpop').on('click',function(){ 
  $('.lookbook_popup').removeClass('active');
  
  });

  /*
  * onload and resize add or remove class
  */

  $(window).on('load resize',function(){ 
  var winWidth = $(window).width();
    
    if(winWidth > 990){
      if($('.lookbook_slider').length > 0){
    $('.lookbook_popup').removeClass('active');
    $('.popup_slides').html(''); 
    }
    }
  
  }); 

$(window).on("load", function(){ 
setTimeout(function(){
   $('.custom-image-slider-jtpl').slick({
   infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    dots: false,
    infinite: true,
    focusOnSelect: true,
    prevArrow : '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
   	nextArrow : '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
        // infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
     ]
}); 
$('.custom-image-slider-jtpl.main-wrapper-cstm-jtpl').css("display","block");
    },500);
  });
});